import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface Country {
  code: string;
  name: string;
  flag: string;
}

// USA first, Brazil second, then common countries, "Other" at the end
const countries: Country[] = [
  { code: "US", name: "Estados Unidos", flag: "🇺🇸" },
  { code: "BR", name: "Brasil", flag: "🇧🇷" },
  { code: "CA", name: "Canadá", flag: "🇨🇦" },
  { code: "GB", name: "Reino Unido", flag: "🇬🇧" },
  { code: "PT", name: "Portugal", flag: "🇵🇹" },
  { code: "ES", name: "Espanha", flag: "🇪🇸" },
  { code: "FR", name: "França", flag: "🇫🇷" },
  { code: "DE", name: "Alemanha", flag: "🇩🇪" },
  { code: "IT", name: "Itália", flag: "🇮🇹" },
  { code: "MX", name: "México", flag: "🇲🇽" },
  { code: "AR", name: "Argentina", flag: "🇦🇷" },
  { code: "CO", name: "Colômbia", flag: "🇨🇴" },
  { code: "CL", name: "Chile", flag: "🇨🇱" },
  { code: "AU", name: "Austrália", flag: "🇦🇺" },
  { code: "JP", name: "Japão", flag: "🇯🇵" },
  { code: "OTHER", name: "Outros", flag: "🌍" },
];

interface CountrySelectProps {
  value: string;
  onChange: (value: string) => void;
}

export const CountrySelect = ({ value, onChange }: CountrySelectProps) => {
  const selectedCountry = countries.find(c => c.code === value) || countries[0];

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full bg-background">
        <SelectValue>
          <span className="flex items-center gap-2">
            <span className="text-base">{selectedCountry.flag}</span>
            <span className="text-sm">{selectedCountry.name}</span>
          </span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="bg-popover z-50 max-h-[300px]">
        {countries.map((country) => (
          <SelectItem key={country.code} value={country.code}>
            <span className="flex items-center gap-2">
              <span className="text-base">{country.flag}</span>
              <span className="text-sm">{country.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

// Helper to get currency from country code
export const getCurrencyFromCountry = (countryCode: string): 'brl' | 'usd' => {
  // Only Brazil uses BRL, everyone else uses USD
  return countryCode === 'BR' ? 'brl' : 'usd';
};
